import { Component, ViewChild, NgZone } from "@angular/core";
import { AppLink, AppLinksCfgService } from "../appLinks/appLinksCfg.service";
import { AccessManagerService } from "../../auth/accessManager/accessManager.service";
import { OfficeSelectorService } from "../officeSelector/officeSelector.service";
import { AppLinksProfessionalsCfgService } from "../appLinks/appLinksProfessionalsCfg.service";
import { FeaturePermissionsService } from "src/app/auth/raas/featurePermissions.service";
import { ModalDialogComponent } from "../modal/modalDialog.component";
import { AccessManagerResourceActionType } from "../../auth/accessManager/accessManager.models";
import { AppGroup } from "./appGroup";
import { BaseComponent } from "../baseComponent";

@Component({
    selector: 'app-selection-dialog',
    templateUrl: './appSelectionDialog.component.html',
    styleUrls: ['./appSelectionDialog.component.css'],
    standalone: false
})
export class AppSelectionDialogComponent extends BaseComponent {
  @ViewChild(ModalDialogComponent, { static: true }) private dialog: ModalDialogComponent;
  public dialogLoading: boolean = false;
  public appGroup = AppGroup;
  public isMobile: boolean = false;
  private mAppLinks: AppLink[];
  public get appLinks(): AppLink[] {
    return this.mAppLinks;
  }
  public appLinksGrid: AppLink[][];

  constructor(zone: NgZone,
    private appLinksCfgService: AppLinksCfgService,
    private appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
    private officeSelectorService: OfficeSelectorService,
    private accessManagerService: AccessManagerService,
    private featurePermissionsService: FeaturePermissionsService) {
    super(zone);
  }

  public async openDialog(title: string, appGroup: AppGroup, isMobile: boolean = false): Promise<void> {
    if (this.officeSelectorService.selectedOffice) {
      try {
        this.isMobile = isMobile;
        this.dialog.title = title;
        this.dialogLoading = true;

        this.mAppLinks = null;

        this.dialog.open();

        let appLinks = (await this.featurePermissionsService.professionalsEnabled() && !this.officeSelectorService.selectedOffice.isTEA) ? this.appLinksProfessionalsCfgService.getCfg().appLinks : this.appLinksCfgService.getCfg().appLinks;
        appLinks = appLinks.filter(x => x.group == appGroup).sort((a, b) => a.order - b.order);

        let grantedAppLinks = [];
        let promises = [];
        for (let i = 0; i < appLinks.length; ++i) {
          let promise = new Promise<void>((resolve, reject) => {
            this.accessManagerService.getResourcePermissions(appLinks[i].resourceId)
              .then((permissions) => {
                if (permissions && permissions.getResourceAction(AccessManagerResourceActionType.WindowAccess)) {
                  grantedAppLinks.push(appLinks[i]);
                  this.doAsyncUIChanges(() => this.mAppLinks = grantedAppLinks.sort((a, b) => a.order - b.order));
                }
                resolve();
              }).catch((error) => {
                reject(error);
              });
          });
          promises.push(promise);
        }

        await Promise.all(promises);
        this.mAppLinks = grantedAppLinks.sort((a, b) => a.order - b.order);

        this.appLinksGrid = this.generateAppGrid(this.appLinks, 3);

      } catch (error) {
        this.dialog.close(null);
        throw error;
      } finally {
        this.dialogLoading = false;
      }
    }
  }

  private generateAppGrid(appLinks: AppLink[], rowWidth: number): AppLink[][] {
    let appLinksGrid: AppLink[][] = [];

    if (appLinks) {
      for (let i = 0; i < appLinks.length; ++i) {
        let row = Math.floor(i / rowWidth);
        if (row >= appLinksGrid.length) appLinksGrid.push(new Array<AppLink>());
        appLinksGrid[row].push(appLinks[i]);
      }
    }

    return appLinksGrid;
  }

  public close(): void {
    this.dialog.close(null);
  }
}
